import { LAG_GS }     from 'AppConfig/Config';
import { formatDate } from 'ClientService';
import { useSelector } from 'react-redux';
import { userContainsRole } from 'Redux/Query';

export const ToSubsequentDeliveryDate = ({ value, record }) => {
  const checkUserRole = useSelector(userContainsRole);

  let now = new Date();
  let toAnswerCompDate = !record.toAnswerDate ? null : new Date(record.toAnswerDate.getFullYear(),
    record.toAnswerDate.getMonth(), record.toAnswerDate.getDate(), 23, 59, 59);
  let tsdCompDate = !record.toSubsequentDeliveryDate ? null : new Date(record.toSubsequentDeliveryDate.getFullYear(),
    record.toSubsequentDeliveryDate.getMonth(), record.toSubsequentDeliveryDate.getDate(), 23, 59, 59);
  let answerDate = !record.answerDate ? new Date(2099,1,1) : new Date(record.answerDate);

  return !toAnswerCompDate || !tsdCompDate ||
  ( (answerDate <= toAnswerCompDate || toAnswerCompDate >= now) && !checkUserRole([ LAG_GS ]))? '' :
    formatDate(record.toSubsequentDeliveryDate);
}
